module.exports = __webpack_public_path__ + "img/icon-1.ecdeb4d1.svg";